"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalNotFoundError = exports.ServiceAlreadyRegisteredError = exports.AgentNotRegisteredError = exports.AgentAlreadyRegisteredError = exports.ServiceNotRegisteredError = void 0;
class ServiceNotRegisteredError extends Error {
    constructor(serviceName) {
        super(`Service "${serviceName}" is not registered.`);
        this.name = "ServiceNotRegisteredError";
    }
}
exports.ServiceNotRegisteredError = ServiceNotRegisteredError;
class AgentAlreadyRegisteredError extends Error {
    constructor(agentAddress) {
        super(`Agent "${agentAddress}" is already registered.`);
        this.name = "AgentAlreadyRegisteredError";
    }
}
exports.AgentAlreadyRegisteredError = AgentAlreadyRegisteredError;
class AgentNotRegisteredError extends Error {
    constructor(agentAddress) {
        super(`Agent "${agentAddress}" is not registered.`);
        this.name = "AgentNotRegisteredError";
    }
}
exports.AgentNotRegisteredError = AgentNotRegisteredError;
class ServiceAlreadyRegisteredError extends Error {
    constructor(serviceName) {
        super(`Service "${serviceName}" is already registered.`);
        this.name = "ServiceAlreadyRegisteredError";
    }
}
exports.ServiceAlreadyRegisteredError = ServiceAlreadyRegisteredError;
class ProposalNotFoundError extends Error {
    constructor(proposalId) {
        super(`Proposal "${proposalId}" not found.`);
        this.name = "ProposalNotFoundError";
    }
}
exports.ProposalNotFoundError = ProposalNotFoundError;
